import { designPresetNames } from "../../design/stylePresets";

export const dashboardGoals = [
    "Executive operations dashboard",
    "KPI monitoring dashboard",
    "Map-first dashboard",
    "Detail explorer",
    "Table/report dashboard",
    "Custom app-style dashboard",
    "Professional operations app",
    "Executive command center",
    "Record explorer",
    "Map command center",
    "Mobile operations view",
];
export const builderAudiences = ["Executive", "Manager", "Analyst", "Field operations", "Public viewer"];
export const layoutPatterns = [
    "KPI top row + charts + detail table",
    "Collapsible left filter panel + main tab content",
    "Map left + details right",
    "Full-width table with filters",
    "Executive summary with exception table",
    "Professional app shell with sidebar",
    "Compact command-center shell",
    "Executive dashboard with page header",
    "Record explorer with details offcanvas",
    "Mobile-responsive operational dashboard",
];
export const builderComponentOptions = [
    "KPI cards",
    "Metric grid",
    "Search box",
    "Filters/selectors",
    "Tabs",
    "Collapsible sections",
    "Charts",
    "Advanced ECharts",
    "Table",
    "Map",
    "Detail panel",
    "Custom HTML/CSS component",
    "External Power BI selection",
    // New primitives
    "Application shell",
    "Card containers",
    "Navigation sidebar",
    "Dropdown actions",
    "Modal/offcanvas details",
    "List group",
    "Data grid",
    "Empty/loading states",
    "Steps",
    "Strong native table",
];
export const stylePresetOptions = designPresetNames;

